import { styled } from '@stitches/react';
import * as Form from '@radix-ui/react-form';
import { useState, useRef, useEffect } from 'react';

//#region Estilos
const InputContainer = styled('div', {
  padding: '10px 10px',
  backgroundColor: '#1C2024',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const StyledForm = styled(Form.Root, {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const InputWrapper = styled('div', {
  flex: 1,
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '8px',
});

const Input = styled('input', {
  flex: 1,
  padding: '9px 12px',
  fontSize: '15px',
  border: 'none',
  width: '100%',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#111b21',
  margin: 0,
  outline: 'none',
  '&::placeholder': {
    color: '#667781',
  },
});

const SendButton = styled('button', {
  background: '#8BA7FF',
  border: 'none',
  padding: '8px 12px',
  cursor: 'pointer',
  color: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  margin:0,
  borderRadius: '8px',
  transition: 'background-color 0.2s',
  '&:disabled': {
    background: '#4a4f53',
    cursor: 'default',
  },
  '&:hover:not(:disabled)': {
    background: '#7B99FF',
  }
});
//#endregion

function InputBar({ handleSendMessage, onTyping, placeholder, showInputButton, iconButton=""}) {
  const [message, setMessage] = useState('');
  const typingTimeoutRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      handleSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
    
    if (onTyping) {
      onTyping(true);
      clearTimeout(typingTimeoutRef.current);
      typingTimeoutRef.current = setTimeout(() => {
        onTyping(false);
      }, 1000);
    }
  };

  useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, []);

  return (
    <InputContainer>
      <StyledForm onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder={placeholder}
            value={message}
            onChange={handleMessageChange}
            onKeyPress={handleKeyPress}
          />
        {showInputButton?
        <SendButton type="submit" disabled={!message.trim()}>
          {iconButton}
        </SendButton>:null}
      </StyledForm>
    </InputContainer>
  );
}

export default InputBar; 